// AbortSignal.any shipped in Safari 17.4, but our supported browsers start at
// Safari 16.4 and the Trigger.dev chat transport calls it unguarded.
function abortSignalAny(signals: Iterable<AbortSignal>): AbortSignal {
  const controller = new AbortController();
  const sources = Array.from(signals);

  const alreadyAborted = sources.find((signal) => signal.aborted);
  if (alreadyAborted) {
    controller.abort(alreadyAborted.reason);
    return controller.signal;
  }

  for (const signal of sources) {
    signal.addEventListener('abort', () => controller.abort(signal.reason), {
      once: true,
      signal: controller.signal,
    });
  }

  return controller.signal;
}

if (typeof AbortSignal !== 'undefined' && typeof AbortSignal.any !== 'function') {
  AbortSignal.any = abortSignalAny;
}
